import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatDatepicker, MatDatepickerInputEvent} from "@angular/material/datepicker";

@Component({
  selector: 'app-form-multiple-datepicker',
  templateUrl: './form-multiple-datepicker.component.html',
  styleUrls: ['./form-multiple-datepicker.component.scss']
})
export class FormMultipleDatepickerComponent {
  public CLOSE_ON_SELECTED = false;
  public init = new Date();
  public resetModel = new Date(0);
  @Input() model!: Date[];
  @Input() placeholder!: string;
  @Output() modelChange: EventEmitter<Date[]> = new EventEmitter<Date[]>();
  @ViewChild('picker', {static: true}) _picker!: MatDatepicker<Date>;

  public dateClass = (date: Date) => {
    if (this._findDate(date) !== -1) {
      return ['selected'];
    }
    return [];
  }

  public dateChanged(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      const date = event.value;
      const index = this._findDate(date);
      if (index === -1) {
        this.model.push(date);
        this.modelChange.emit(this.model);
      } else {
        this.model.splice(index, 1)
      }
      this.resetModel = new Date(0);
      if (!this.CLOSE_ON_SELECTED) {
        const closeFn = this._picker.close;
        this._picker.close = () => {
        };
        this._picker['_componentRef'].instance._calendar.monthView._createWeekCells()
        setTimeout(() => {
          this._picker.close = closeFn;
        });
      }
    }
  }

  public remove(date: Date): void {
    const index = this._findDate(date);
    this.model.splice(index, 1)
  }

  private _findDate(date: Date): number {
    return this.model.map((m) => +m).indexOf(+date);
  }
}
